import { render } from "./AdminContactUs.vue?vue&type=template&id=4e43d0c6&scoped=true"
import script from "./AdminContactUs.vue?vue&type=script&lang=js"
export * from "./AdminContactUs.vue?vue&type=script&lang=js"

import "./AdminContactUs.vue?vue&type=style&index=0&id=4e43d0c6&lang=scss&scoped=true"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e43d0c6"]])

export default __exports__